document.addEventListener("DOMContentLoaded", function() {
 document.querySelectorAll('[data-toggle-contact-drawer]').forEach(item => {
  item.addEventListener('click', function(e) {
    e.preventDefault();

    var contactDrawer = document.querySelector('[data-section-type="contact-drawer"]');
    contactDrawer.classList.remove('translate-x-full');
    contactDrawer.classList.add('hover-translate-x-full');

    var overlay = document.getElementById('contact-drawer-overlay');
    overlay.style.display = 'block';
  });
});

document.getElementById('contact-drawer-overlay').addEventListener('click', function(e) {
  e.preventDefault();

  var contactDrawer = document.querySelector('[data-section-type="contact-drawer"]');
  contactDrawer.classList.remove('hover-translate-x-full');
  contactDrawer.classList.add('translate-x-full');

  // Optionally, if you want to hide the overlay after clicking it
  this.style.display = 'none';
});


  
});




$(document).ready(function () 
  {
      updateContainer();
      $(window).resize(function() 
      {  updateContainer(); });
  });
  function updateContainer() {
 
  var width = $(window).width();
  if(width < 1024){
  $(".template-product .product-content-container .product-add").addClass("sticky-addcart");
  $(".template-product .product-content-container .add-to-cart-container").addClass("opacity");    
  $(window).scroll(function() 
  {    
    var scroll = $(window).scrollTop();   
    //console.log(scroll);
    if (scroll >= 4200) {
         $(".template-product .product-content-container .product-add").removeClass("sticky-addcart");
         $(".template-product .product-content-container .add-to-cart-container").removeClass("opacity");
           
    }
    else
    {
         $(".template-product .product-content-container .product-add").addClass("sticky-addcart");
         $(".template-product .product-content-container .add-to-cart-container").addClass("opacity");
    }
  });
  $(".template-product .product-content-container .product-add #addToCartButton").click(function() {
    $('html, body').animate({
        scrollTop: $(".template-product .product-content-container .shopify-product-form").offset().top - 300 
    }, 2000);
  });  
  }

  }  
